import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import Upgrade401kModal from "../components/Upgrade401kModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine, faChartSimple, faArrowUp, faArrowDown, faUsd, faChartPie, faMagnifyingGlass, faCircleNotch, faClock } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

function Transaction() {
  const { user } = useUser();
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [enrollment, setEnrollment] = useState([]);
  const [contribution_rate, setContribution_rate] = useState(0);
  const [allSavings, setAllSavings] = useState([]);
  const [totalSavings, setTotalSavings] = useState(0);
  //get total
  const contribution = allSavings.filter((item) => item.type === "savings" && item.status === "success");
  const totalContribution = contribution.reduce((sum, item) => sum + parseFloat(item.amountUSD || 0),0);
  const dividends = allSavings.filter((item) => item.type === "dividend" && item.status === "success");
  const totalDividends = dividends.reduce((sum, item) => sum + parseFloat(item.amountUSD || 0),0);
  const employee = allSavings.filter((item) => item.type === "employee match" && item.status === "success");
  const totalEmployee = employee.reduce((sum, item) => sum + parseFloat(item.amountUSD || 0),0);
  const withdrawal = allSavings.filter((item) => item.type === "withdrawal" && item.status === "success");
  const totalWithdrawal = withdrawal.reduce((sum, item) => sum + parseFloat(item.amountUSD || 0),0);
  const maintenance = allSavings.filter((item) => item.type === "maintenance" && item.status === "success");
  const totalMaintenance = maintenance.reduce((sum, item) => sum + parseFloat(item.amountUSD || 0),0);
  useEffect(() => {
    let rate = 1;
    if(user?.frequency == "monthly"){
      rate = 1;
    }else if(user?.frequency == "bi-weekly" || user?.frequency == "semi-monthly"){
      rate = 0.5;
    }
    setContribution_rate(rate);
  }, [user])
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchEnrollment: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setEnrollment(data.enrollment)
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsavings: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings1 = data.all.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            amountUSD = asset.price * tx.amount;
          }else{
            logo = `/uploads/usd.svg`;
            symbol = "USD";
            amountUSD = tx.amount;
          }
          return {
            ...tx,
            logo,
            symbol,
            amountUSD
          };
        });
        setAllSavings(updatedSavings1);
        const amounts = updatedSavings1.map(item => parseFloat(item.amountUSD) || 0);
        const total = amounts.reduce((sum, n) => sum + n, 0);
        setTotalSavings(total);
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  const [search, setSearch] = useState('');
  // Filtered data based on search
  const filteredSavings = allSavings.filter(
    (item) =>
      item.type.toLowerCase().includes(search.toLowerCase()) ||
      item.amount.toString().includes(search) || item.method.toLowerCase().includes(search.toLowerCase()) ||
      item.date.includes(search) || item.description.toLowerCase().includes(search.toLowerCase())
  );

  if (!enrollment || typeof enrollment !== 'object' || Object.keys(enrollment).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Upgrade401kModal UserDetails={user} enrollment={enrollment} />
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Transactions" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar"> 
          <Header title="Transactions" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="container mb-5">
            <h2 className="mt-3 mb-0" style={{fontWeight:'900'}}>Transactions</h2>
            <p class="mb-0" style={{fontSize: '14px'}}>View and manage your 401k account activity</p>
            <div className="row">
                <div className="col-lg-9 g-4">
                    <div className="mycard p-3 overflow-hidden" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center mb-4">
                            <FontAwesomeIcon icon={faChartLine} className="text-info" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Transaction History</h5>
                        </div>
                        <div className="d-flex align-items-center form-control py-1 pe-1 mt-4 mb-3">
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="text-secondary me-3" style={{fontSize: '14px'}} />
                            <input 
                                type="search"
                                placeholder="Search transactions..."
                                className="inputNone flex-1"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                        {filteredSavings.length > 0 ? (
                          filteredSavings.slice(0, 10).map((history, index) => (
                          <div key={index} className="mb-2 p-3 rounded-3 d-flex align-items-center justify-content-between mb-3" style={{border:'1px solid #a9a9a90f'}}>
                            <div className="d-flex align-items-center">
                              {history.status === "pending" ? (
                                <FontAwesomeIcon icon={faClock} className="text-warning" style={{ fontSize: "14px" }} />
                              ) :history.type === "dividend" ? (
                                <FontAwesomeIcon icon={faUsd} className="text-info" style={{ fontSize: "14px" }} />
                              ) : history.type === "withdrawal" || history.type === "maintenance" ? (
                                <FontAwesomeIcon icon={faArrowDown} className="text-danger" style={{ fontSize: "14px" }} />
                              ) : (
                                <FontAwesomeIcon icon={faArrowUp} className="text-success" style={{ fontSize: "14px" }} />
                              )}
                              <div className="ms-3">
                                  <p className="mb-0 fw-semibold">{history.type == "dividend" ? 'Dividend' :history.type == "employee match" ? 'Employer Match' :history.type == "withdrawal" ? 'Withdrawals' :history.type == "maintenance" ? 'Maintenance' : 'Contribution'}</p>
                                  <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>{history.description}</p>
                              </div>
                            </div>
                            <div className="text-end">
                                <p className={`${history.status == "pending" ? 'text-warning' :history.type == "withdrawal" || history.type == "maintenance" ? 'text-danger' : 'text-success'} mb-0 fw-semibold`}>{history.type == "withdrawal" || history.type == "maintenance" ? '-' : '+'}{getCurrencySymbol(user?.currency)}{formatCurrency(history.amountUSD * rate)}</p>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>{history.date}</p>
                            </div>
                          </div>
                          ))
                        ) : (
                          <p className="py-5 text-center mb-0" style={{fontSize:'14px'}}>You have not made any activity yet.</p>
                        )}
                        <hr style={{opacity:'0.07'}}/>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Showing {filteredSavings.length} transactions</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Total: {getCurrencySymbol(user?.currency)}{formatCurrency(totalSavings * rate)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 g-4">
                    <div className="mycard p-3 overflow-hidden" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center mb-4">
                            <FontAwesomeIcon icon={faChartPie} className="text-info" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Summary</h5>
                        </div>
                        <div className="p-3 d-flex  align-items-center justify-content-between rounded-3 mb-2" style={{backgroundColor:'#ff6b3509'}}>
                            <p className="mb-0" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faArrowUp} className="text-prime me-1" style={{fontSize: '15px'}} /> Your Contributions</p>
                            <div className="text-end">
                                <p className="mb-0 text-prime" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalContribution * rate)}</p>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{contribution.length} transactions</p>
                            </div>
                        </div>
                        <div className="p-3 d-flex  align-items-center justify-content-between rounded-3 mb-2" style={{backgroundColor:'#f00d0d12'}}>
                            <p className="mb-0" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faArrowDown} className="text-danger me-1" style={{fontSize: '15px'}} /> Maintenance Fees</p>
                            <div className="text-end">
                                <p className="mb-0 text-danger" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalMaintenance * rate)}</p>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{maintenance.length} transaction</p>
                            </div>
                        </div>
                        <div className="p-3 d-flex  align-items-center justify-content-between rounded-3 mb-2" style={{backgroundColor:'#19875411'}}>
                            <p className="mb-0" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faArrowUp} className="text-success me-1" style={{fontSize: '15px'}} /> Employer Match</p>
                            <div className="text-end">
                                <p className="mb-0 text-success" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalEmployee * rate)}</p>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{employee.length} transactions</p>
                            </div>
                        </div>
                        <div className="p-3 d-flex  align-items-center justify-content-between rounded-3 mb-2" style={{backgroundColor:'#0dcaf012'}}>
                            <p className="mb-0" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faArrowUp} className="text-info me-1" style={{fontSize: '15px'}} /> Dividends</p>
                            <div className="text-end">
                                <p className="mb-0 text-info" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalDividends * rate)}</p>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{dividends.length} transaction</p>
                            </div>
                        </div>
                        <div className="p-3 d-flex  align-items-center justify-content-between rounded-3" style={{backgroundColor:'#f00d0d12'}}>
                            <p className="mb-0" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faArrowDown} className="text-danger me-1" style={{fontSize: '15px'}} /> Withdrawals</p>
                            <div className="text-end">
                                <p className="mb-0 text-danger" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalWithdrawal * rate)}</p>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>{withdrawal.length} transaction</p>
                            </div>
                        </div>
                        <hr style={{opacity:'0.07'}}/>
                        <div className="mycard p-3 d-flex align-items-center justify-content-between rounded-3 mb-2">
                            <p className="mb-0">Net Cash Flow</p>
                            <h5 className="mb-0 text-success" style={{fontWeight:'900'}}>+{getCurrencySymbol(user?.currency)}{formatCurrency(totalSavings * rate)}</h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Average contribution:</p>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency((contribution_rate * Number(enrollment?.monthly_salary)) * (Number(user?.savings_rate) / 100))}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Total transactions:</p>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{allSavings.length}</p>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Transaction